import { Box, Checkbox, Radio,  Text } from '@chakra-ui/react'
import React from 'react'
import { MdOutlineDelete } from 'react-icons/md'

export const AddedQuestion = ({el,i,handleDelete}) => {
    console.log(el)
  return (
 <Box mt="10">
    {/* <Box>
        <Text> {el.title}</Text>
    </Box> */}
    <Box border="1px solid gray" p="2" boxShadow={"md"} rounded="2xl" >
      <Box display={"flex"} justifyContent={"space-between"}>
      <Box>
      <Box display={"flex"} gap="2" >
        <Text fontSize={"lg"} fontWeight="semibold">{i+1} .</Text>
        <Text fontSize={"lg"} fontWeight="semibold">{el.questionText} ?</Text>
        </Box>
        {el.questionType==='MCQ'&&<Box display={"flex"} justifyContent={"end"} gap="10">
       
            {el?.options?.map((option,i)=>{
                return (<Box key={i}   >
                    <Checkbox >{option.optionText}</Checkbox>
                   
                </Box>)
            })}
            
        </Box>}
      </Box>
        <Box cursor={"pointer"}  onClick={()=>handleDelete(el.id)} mt="3"><MdOutlineDelete size="25"/></Box>
      </Box>
        {el.questionType==="YES_NO"&&<Box display={"flex"} gap="5">
        <Radio value='1'>Yes</Radio>
        <Radio value='2'>No</Radio>
        {/* <Box cursor={"pointer"} onClick={()=>handleDelete(el.id)} ml="400px"><MdOutlineDelete size="25"/></Box> */}
        {/* <Text border={"1px solid"} p="1" color="red" backgroundColor={"black"}  >Delete</Text> */}
            </Box>}
    </Box>
 </Box>
  )
}
